import Detail from './detail'
import { HTTPAUTH } from '../httplib'

export default class Header {
  constructor (invoiceNum, date, customer, method, notes, courier,
    details, toast, refs, channel, invoiceSeq) {

    if (!details) {
      details = []
    }
    this.id = null
    this.invoiceNum = invoiceNum
    this.invoiceSeq = invoiceSeq
    this.faktur = "-"
    this.date = date
    this.customer = customer
    this.method = method
    this.channel = channel
    this.channel_id = 0;
    this.notes = notes
    this.courier = courier
    this.details = details
    this.toast = toast
    this.refs = refs
    this.total = 0
    this.created_at = new Date()
    this.getPaymentMethod(1)
    this.amount = 0
    this.status = 0
    this.edit_reason = ''
  }

  addDetail (detail) {
    const msg = this.validate(detail)
    if (msg != '') {
      this.toast
        .info(msg)
        .goAway(3000);
      return
    }
    detail.setPrice(this.customer, this.method)
    this.details.push(detail)
    /** recalculate total */
    this.calculateTotal()
  }

  validate (detail) {
    if (detail.qty_real < 0) {
      return 'Masukkan qty minimal 1'
    }
    const details = this.details
    if (!this.toast) {
      return ''
    }
    for (var i in details) {
      const dtl = details[i]
      if (dtl.warranty.id && detail.warranty.id && dtl.warranty.id === detail.warranty.id) {
        return `Data: ${detail.item.name}<br/>Dengan kode garansi ${detail.item.warranty}<br/>Sudah ditambahkan`
      }
    }
    return ''
  }

  addDetailParse (obj) {
    const dtl = new Detail(obj.item, obj.editable, obj.qty_real, obj.include_delivery_letter)
    this.addDetail(dtl)
  }

  save () {
    localStorage._trans = JSON.stringify(this)
  }

  calculateTotal () {
    this.total = 0
    const details = this.details
    for (var i in details) {
      const dtl = details[i]
      this.total += parseInt(dtl.price)
    }
    this.total
  }

  recalculatePrice () {
    this.total = 0
    const details = this.details
    for (var i in details) {
      const dtl = details[i]
      if (dtl) {
        dtl.setPrice(this.customer, this.method)
      }
      this.total += parseInt(dtl.price) * dtl.qty_real
    }
    this.save()
  }

  get () {
    const data = localStorage._trans
    if (!data) {
      const hdr = new Header()
      hdr.generateNumbers()
      return hdr
    }

    if (!(data && data.invoice)) {
      this.generateNumbers()
    }

    const obj = Object.assign(this, JSON.parse(data))
    const details = obj.details
    obj.details = []
    for (var i in details) {
      obj.addDetailParse(details[i])
    }
    return obj
  }

  setChannel () {
    console.log(this.channel);
    if (this.channel && this.channel.id) {
      this.channel_id = this.channel.id;
    }
  }

  populate (item) {
    console.log(item, 'item ini')
    this.id = item.id
    this.invoice = item.invoice
    this.invoice_seq = item.invoice_seq
    this.faktur = item.faktur
    this.date = item.created_at
    this.customer = item.customer
    this.method = item.method
    this.notes = item.notes
    this.status = item.status
    this.courier = item.courier
    this.note = item.note
    this.channel_id = item.channel_id
    this.method = item.method
    this.cash = parseFloat(item.cash)
    this.total = item.total
    this.created_at = item.created_at
    // this.getPaymentMethod(this.method)
    this.getChannel(this.channel_id)
    this.amount = item.cash
    this.kembalian = item.cash - item.total
    const details = item.sale_details
    for (var i in details) {
      const dtl = details[i]
      // const detail = new Detail(dtl, false, dtl.qty_real, dtl.include_delivery_letter)
      // console.log(detail, 'abc')
      this.details.push(dtl)
    }
    return this
  }

  removeItem (index) {
    const item = this.details[index]
    this.details.splice(index, 1);
    /** update storage */
    this.save()
    /** recalculate total */
    this.calculateTotal()
    return item.item
  }

  reset () {
    const hdr = new Header()
    hdr.generateNumbers()
    hdr.save()
    return hdr
  }

  generateNumbers (customerId) {
    HTTPAUTH.get("/api/v1/sale/generate/number/" + customerId)
      .then(res => {
        const data = res.data.data;
        this.faktur = data.invoice_system;
        this.invoice = data.invoice;
        this.invoice_seq = data.invoice_seq;
        this.include_delivery_letter = data.include_delivery_letter;
      })
      .catch((eres) => {
        console.log(eres, 'generate numbers')
      });
  }

  getPaymentMethod (id) {
    HTTPAUTH.get("/api/v1/payment-method/" + id).then(res => {
      this.method = res.data.data;
    });
  }

  getChannel (id) {
    HTTPAUTH.get("/api/v1/sale-channels/" + id).then(res => {
      this.channel = res.data.data;
    });
  }

  getCustomer (cid) {
    HTTPAUTH.get("/api/v1/customer/" + cid).then(res => {
      this.customer = res.data.data;
    });
  }
}
